import {
  getStoredToken,
  sessionChecker,
} from '../../../services/user/SessionChecker';
import { parseFetchError } from '../../../utils/http';
import { config } from '../../../config';

const home = data => {
  const token = getStoredToken();
  if (token) {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.audit.prefix +
          config.api_routes.modules.audit.services.home;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return new Promise(async (resolve, reject) => {
      document.location.href = config.appURI;
      reject({
        respCode: -1,
        message:
          'No ha iniciado sesión por lo tanto no puede ingresar a esta opción',
      });
    });
  }
};

const editNotification = id => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.audit.prefix +
          config.api_routes.modules.audit.services.getNotification;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({ id }),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return new Promise(async (resolve, reject) => {
      document.location.href = config.appURI;
      reject({
        respCode: -1,
        message:
          'No ha iniciado sesión por lo tanto no puede ingresar a esta opción',
      });
    });
  }
};

export { home, editNotification };
